<template>
  <div class="papergrad">
    <el-form style="border-bottom: 1px dashed #d0d0d0">
      <el-form-item style="width: 400px">
        <div class="itemtitle"><span>*</span>{{ $t('Education.languages10') }}</div>
        <el-input v-model="ReadOverInfo.relName" disabled style="width:280px"></el-input>
      </el-form-item>

      <el-form-item style="width: 600px">
        <div class="itemtitle"><span>*</span>{{ $t('Education.languages46') }}</div>
        <el-input v-model="ReadOverInfo.examTitle" disabled style="width:480px"></el-input>
      </el-form-item>

      <el-form-item style="width: 400px;">
        <el-row >
          <el-col :span="5"><div class="itemtitle"><span>*</span>{{ $t('Education.languages61') }}</div></el-col>
          <el-col :span="3" style="margin: 0 5px"><el-input v-model="ReadOverInfo.examQuestionNum" disabled></el-input></el-col>
          <el-col :span="1">{{$t('Education.languages56')}}</el-col>
          <el-col :span="2" :offset="2">{{ $t('Education.languages57') }}</el-col>
          <el-col :span="3" style="margin: 0 5px"><el-input v-model="ReadOverInfo.examQuestionScore" disabled></el-input></el-col>
          <el-col :span="1">{{$t('Education.languages58')}}</el-col>
        </el-row>
      </el-form-item>
      <el-form-item style="width: 400px;">
        <el-row>
          <el-col :span="5"><div class="itemtitle"><span>*</span>{{$t('Education.languages62')}}</div></el-col>
          <el-col :span="12" style="margin: 0 5px"><el-input :value="ReadOverInfo.examQuestionScore*ReadOverInfo.examQuestionNum" disabled class="total"></el-input></el-col>
        </el-row>
      </el-form-item>
      <el-form-item>
        <el-row>
          <el-col :span="8"><div class="itemtitle"><span>*</span>考生学号</div>{{ReadOverInfo.userID }}</el-col>
          <el-col :span="5"><div class="itemtitle"><span>*</span>考生姓名</div>{{ReadOverInfo.realName }}</el-col>
        </el-row>
      </el-form-item>
    </el-form>

    <el-form style="border-bottom: 1px dashed #d0d0d0">
      <el-form-item>
        <p style="text-align: center;font-size: 26px;padding:30px 30px 0">{{ReadOverInfo.examTitle}}</p>
      </el-form-item>

      <el-form-item style="margin:0;">
        <el-row>
          <h1>{{ $t('Education.languages61') }}</h1>
        </el-row>
      </el-form-item>
      <el-form-item v-for="item in ReadOverInfo.questionInfos">
        <el-row style="padding:0 20px;">{{item.questionTitle}}?</el-row>
        <el-row style="padding:0 40px 10px;line-height: 28px;">
          <el-input type="textarea" v-model="item.userAnswer" disabled></el-input>
        </el-row>
        <el-row style="width: 300px;padding-left: 40px">
          <el-col :span="6"><span style="color: red">*</span>{{ $t('Education.languages76') }}：</el-col>
          <el-col :span="12"><el-input v-model="item.userQuestionScore" value="10"></el-input></el-col>
        </el-row>
      </el-form-item>
    </el-form>
    <div style="margin:30px auto;display: block;text-align: center">
      <el-button type="primary" @click="submitreadover">{{ $t('Education.languages14') }}</el-button>
      <el-button @click="$router.go(-1)">{{ $t('Education.languages15') }}</el-button>
    </div>

  </div>
</template>

<script>
export default ({
  name:'papergrad',
  data(){
    return{
      ReadOverInfo:"",
      params:{
        examRecordId:'',
        questionInfos:[]
      }
    }
  },
  created() {
    this.getReadOverInfo();
  },
  methods:{
    getReadOverInfo(){
      this.$Http_Post('edu/examRecord/getReadOverInfo',{examRecordId:this.$route.query.examRecordId}).then(res=>{
        if(res.Code==0){
          this.ReadOverInfo=res.Data;
          this.params.examRecordId=res.Data.examRecordId;
        }else{
          this.$message({type: 'error', message:res.Message});
        }
      })
    },
    // 提交批阅
    submitreadover(){
      for(let item of this.ReadOverInfo.questionInfos){
        let str={examRecordDetailId:item.examRecordDetailId,userQuestionScore:item.userQuestionScore}
        this.params.questionInfos.push(str);
      };
      let a=this.params.questionInfos;
      this.$Http_Post('edu/examRecord/readOver',this.params).then(res=>{
        if(res.Code==0){
          this.$message({type: 'success', message:res.Message});
        }else{
          this.$message({type: 'error', message:res.Message});
        }
      })
    }
  },
})
</script>

<style scoped>
.papergrad{background: #fff;padding:30px;}
.papergrad .itemtitle{display: inline-block;margin-right: 10px;width:80px;text-align: right}
.papergrad .itemtitle span{color: red;}
</style>